/*
 * Crestarize cart drawer extras (Dawn).
 * - "Cart reserved" countdown: one end time per browser session, shown in every [data-crz-timer].
 * - "+ Add" upsell buttons ([data-crz-add]) and the Priority Shipping switch ([data-crz-toggle]).
 * After a cart change the drawer is re-rendered from the cart-drawer section, like Dawn does.
 */
(function () {
  'use strict';
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  function post(path, body) {
    return fetch(root() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function refresh() {
    return fetch(root() + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sec) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && sec['cart-drawer']) {
          var doc = new DOMParser().parseFromString(sec['cart-drawer'], 'text/html');
          var fresh = doc.querySelector('.drawer__inner');
          var curr = drawer.querySelector('.drawer__inner');
          if (fresh && curr) curr.innerHTML = fresh.innerHTML;
          drawer.classList.toggle('is-empty', !!doc.querySelector('cart-drawer.is-empty'));
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sec['cart-icon-bubble']) {
          var bdoc = new DOMParser().parseFromString(sec['cart-icon-bubble'], 'text/html');
          var inner = bdoc.querySelector('.shopify-section');
          if (inner) bubble.innerHTML = inner.innerHTML;
        }
        tick();
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-crz-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    post('cart/add.js', { items: [{ id: Number(btn.getAttribute('data-crz-add')), quantity: 1 }] })
      .then(refresh)
      .catch(function () {
        btn.disabled = false;
        btn.textContent = btn.getAttribute('data-crz-label-default') || '+ Add';
      });
  });

  document.addEventListener('change', function (e) {
    var sw = e.target.closest('[data-crz-toggle]');
    if (!sw) return;
    var id = Number(sw.getAttribute('data-crz-toggle'));
    sw.disabled = true;
    var req = sw.checked
      ? post('cart/add.js', { items: [{ id: id, quantity: 1 }] })
      : post('cart/change.js', { id: String(id), quantity: 0 });
    req.then(refresh, refresh);
  });

  var KEY = 'crzCartTimerEnd';
  function tick() {
    var els = document.querySelectorAll('[data-crz-timer]');
    if (!els.length) return;
    var now = Date.now();
    var end = 0;
    try { end = parseInt(sessionStorage.getItem(KEY), 10) || 0; } catch (err) { end = 0; }
    if (!end) {
      end = now + (parseInt(els[0].getAttribute('data-crz-timer'), 10) || 300) * 1000;
      try { sessionStorage.setItem(KEY, String(end)); } catch (err) {}
    }
    var left = Math.max(0, end - now);
    var m = Math.floor(left / 60000);
    var s = Math.floor((left % 60000) / 1000);
    var txt = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    els.forEach(function (el) {
      var out = el.querySelector('[data-crz-timer-out]');
      if (out) out.textContent = txt;
    });
  }
  setInterval(tick, 1000);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tick);
  else tick();
})();
